import { Crosshair } from "lucide-react";
import { useDepartmentStore } from "@/features/department";

const CONTEXT_TYPE_LABELS: Record<string, string> = {
  ecommerce_product: "Product",
  ecommerce_metrics: "Metrics",
  ecommerce_ad_cost: "Ad Cost",
  ecommerce_strategy: "Strategy",
  ecommerce_portfolio: "Portfolio",
};

export function SentContextBadges({ messageId, compact }: { messageId: string; compact?: boolean }) {
  const contexts = useDepartmentStore((s) => s.sentMessageContexts[messageId]);
  if (!contexts?.length) return null;

  return (
    <div className={`flex flex-wrap gap-1 ${compact ? "mt-0.5 px-0.5" : "mt-1.5 px-1"}`}>
      <Crosshair
        className={`${compact ? "w-2.5 h-2.5" : "w-3 h-3"} text-cyan-400/60 shrink-0 mt-0.5`}
      />
      {contexts.map((ctx, i) => (
        <span
          key={i}
          className={`ds-micro inline-flex items-center gap-1 rounded-full border border-cyan-500/25 bg-cyan-500/10 text-cyan-300 ${
            compact ? "px-1.5 py-px" : "px-2 py-0.5"
          }`}
        >
          <span className="font-bold uppercase tracking-wider opacity-80">
            {CONTEXT_TYPE_LABELS[ctx.type] || ctx.type}
          </span>
          <span className="max-w-[90px] truncate opacity-60">{ctx.label}</span>
        </span>
      ))}
    </div>
  );
}
